import { IConversation } from '../../models/IConversation';
import getUrlInfo from './getUrlInfo';

function getConversationId(conversations: IConversation[]) {
    let conversationId = null;
    const { conversationName } = getUrlInfo();

    if (conversationName && conversations) {
        for (let i = 0; i < conversations.length; i++) {
            if (conversations[i].name === conversationName) {
                conversationId = conversations[i].id;
                break;
            }
        }
    }

    return conversationId;
}

export default getConversationId;
